
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/addPreset/addSection/components/RawThumbnail.scss.css.virtualfile';
        module.exports = {"wrapper":"_wrapper_1v3lb_1","preview":"_preview_1v3lb_8","loading":"_loading_1v3lb_12"};